(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableEditSearch =  function (){

    $(".js-modify-search button, #js-edit-button, .js-modify-search-btn").on('click',function(e){
      e.preventDefault();
      $(".js-modify-search").hide();
      $(".js-results-overflow").show();
      $(".js-main-form").show();
	  
	  if($(".js-main-form").is(':visible')){
		scrollToDivParam(this,'.js-main-form','1')
	  }
      // $('#daterange').data('dateRangePicker').setStart('01/10/2017');
      // $('#daterange').data('dateRangePicker').setEnd('10/10/2017');
    });

    $(".js-results-overflow").on('click',function(e){
      e.preventDefault();
      $(this).hide();
      $(".js-main-form").hide();
      $(".js-modify-search").show();
    });

  };


})(jQuery);
